export default () => {
	// Function to handle smooth scrolling when clicking on links with class 'scroll-link'
	function scrollToElement(e) {
		e.preventDefault();

		const targetId = e.target.getAttribute('href').substring(1); // Remove '#' from href
		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth' });
		}
	}

// Attach the event listener to all links with class 'scroll-link'
	const scrollLinks = document.querySelectorAll('.scroll-link');
	scrollLinks.forEach(link => {
		link.addEventListener('click', scrollToElement);
	});

}



